import { render } from "./FileType.vue?vue&type=template&id=7185d3b6&scoped=true&ts=true"
import script from "./FileType.vue?vue&type=script&lang=ts"
export * from "./FileType.vue?vue&type=script&lang=ts"

import "./FileType.vue?vue&type=style&index=0&id=7185d3b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7185d3b6"]])

export default __exports__